import _ from 'lodash';

const columnNames = {
    age: 'age_group',
    race: 'race',
    gender: 'gender',
    job: 'job_family',
    time: 'time_type',
    shift: 'work_shift',
    worker: 'worker_sub_type',
    location: 'location_hierarchy',
    hr: 'hr_company_name',
    company: 'company',
    cc: 'cost_center',
    ccn: 'cost_center_name',
    backup: 'backup_unit',
    veteran: 'veteran_status',
    ethnicity: 'ethnicity',
    employment: 'employment',
    specialty: 'physician_specialty',
    unit: 'unit',
    position: 'position',
    loc: 'location_description'
}

const getUrlPart = (key, value) => `&filter-${columnNames[key]}=${encodeURIComponent(value)}`;

export const getFilterUrlPart = (filters, otherFilters) => {

    if (!otherFilters && filters.otherFilters)
        otherFilters = filters.otherFilters;

    const base_filters = Object.keys(columnNames)
        .filter( key => Array.isArray(filters[key]) && filters[key].length > 0)
        .map( key => filters[key].map( fv => getUrlPart(key, fv)).join(''));
    
    const other_filters = otherFilters ? Object.keys(otherFilters).map( key => Array.isArray(otherFilters[key])
        ?  otherFilters[key].map( value => `&filter-${key}=${encodeURIComponent(value)}`).join('')
        : `&filter-${key}=${encodeURIComponent(otherFilters[key])}`
    ) : [];

    return [...base_filters, ...other_filters]
    .filter(r => r)
    .join('');
}

export const getBenchmarksParam = (appliedBenchmark, units, workSettingBenchmarks, datasetBenchmarks) => {
  let benchmarksParam = '';
  const workSettingBenchmarksArray = workSettingBenchmarks.split(',').map(str => str.trim());
  const datasetBenchmarksArray = datasetBenchmarks.split(',').map(str => str.trim());
  if (appliedBenchmark && units) {
    benchmarksParam += _.includes(workSettingBenchmarksArray, appliedBenchmark) ? appliedBenchmark : workSettingBenchmarksArray[0];
  }
  if (appliedBenchmark && !units) {
    benchmarksParam += _.includes(datasetBenchmarksArray, appliedBenchmark) ? appliedBenchmark : datasetBenchmarksArray[0];
  }
  if (!appliedBenchmark) {
    benchmarksParam += units ? workSettingBenchmarksArray[0] : datasetBenchmarksArray[0];
  }
  return benchmarksParam;
}

export const getBenchmarkLabel = (benchmark, unit) => {
  let benchmarkLabel = '';
  if (benchmark) {
    if (unit === 'all') {
      let benchmarkType = benchmark.indexOf("facility") > -1 ? "facilities" : "work settings";
      const benchmarkYear = benchmark.substring(0, 4);
      const benchmarkQuarter = benchmark.substring(5, 7);
      let benchmarkRegion = "";
      if (/_us(_|$)/.test(benchmark)) {
        benchmarkRegion = "US";
      } else if (/_uk(_|$)/.test(benchmark)) {
        benchmarkRegion = "UK";
      } else if (/_ca(_|$)/.test(benchmark)) {
        benchmarkRegion = "Canadian";
      }
      if (benchmarkRegion === "UK") {
        benchmarkType = "work settings";
      }
      benchmarkLabel = `${benchmarkYear} ${benchmarkQuarter} ${benchmarkRegion} ${benchmarkType}`.toUpperCase();

      if (/_magnet(_|$)/.test(benchmark)) {
        benchmarkLabel = benchmarkLabel.replace("MAGNET","MEDIAN");
      }

    } else {
      const workSettingIndex = benchmark.indexOf('ws');
      const rawBenchmarkName = workSettingIndex > -1 ? benchmark.substring(workSettingIndex + 3) : benchmark;
      benchmarkLabel = rawBenchmarkName.split('_').join(' ').toUpperCase();

      if (/_magnet(_|$)/.test(benchmark)) {
        benchmarkLabel = benchmarkLabel.replace("MAGNET","MEDIAN");
      }

    }
  }
  return benchmarkLabel;
}

export const parseUnitMapping = (comparativeUnitMappings) => {
  var unitMapping = {};

  var groups = [];
  if (typeof comparativeUnitMappings !== "undefined" && comparativeUnitMappings !== "undefined" &&
    comparativeUnitMappings && comparativeUnitMappings !== "null" && comparativeUnitMappings.length > 0) {
    // Support either a multi-line or || delimited list of comparison mappings
    comparativeUnitMappings = comparativeUnitMappings.replace("||","\n");
    var entries = comparativeUnitMappings.split("\n");
    for (var row = 0; row < entries.length; row++) {
      var columns = entries[row].split("|");
      var currentEntry = "";
      for (var col = 0; col < columns.length; col++) {
        if (row === 0) {
          // Process header row with groups
          groups[col] = columns[col];
        } else if (columns[0] && columns[col].length>0 && columns[col] && columns[col].length>0) {
          // Process a mapping row
          if (col === 0) {
            unitMapping[columns[col]] = {};
            currentEntry = columns[col];
          } else {
            unitMapping[currentEntry][groups[col]] = columns[col];
          }
        }
      }
    }
  }

  return unitMapping;
}



// WEBPACK FOOTER //
// ./src/lib/utils/index.js